import { Grid2 as Grid, styled } from '@mui/material';

import { DataGridList } from '@mewa/ui';

const DataGrid = ({ title, items }: { title?: string; items: string[] }) => {
  return (
    <DataGridContainer>
      <Grid container columns={5}>
        <Grid
          size={{
            xs: 12,
            md: title ? 2 : 0,
          }}
        >
          <DataGridTitle>{title}</DataGridTitle>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: title ? 3 : 5,
          }}
        >
          <DataGridList items={items} />
        </Grid>
      </Grid>
    </DataGridContainer>
  );
};

export default DataGrid;

export const DataGridContainer = styled('div')({
  borderTop: '1px solid var(--color-medium-light-grey)',
  paddingTop: '16px',
  paddingBottom: '16px',

  '&:first-of-type': {
    borderTop: 0,
    paddingTop: 0,
  },
});

const DataGridTitle = styled('p')(({ theme }) => ({
  ...theme.typography.body,
  fontWeight: theme.typography.fontWeightMedium,
  margin: 0,

  [theme.breakpoints.down('sm')]: {
    marginBottom: '7px',
  },
}));
